<p-floatlabel>
  @if (multiple) {
    <p-multi-select
      [id]="'enum-filter-element-' + inputId"
      [options]="options"
      optionValue="key"
      optionLabel="value"
      (onChange)="onFilterChange($event)"
      (onClear)="onFilterChange(null)"
      [showClear]="true"
      [fluid]="true"
      [filter]="searchable"
      [showToggleAll]="false"
      filterBy="value"
      [(ngModel)]="value"
      (onFilter)="onFilterTermChange($event.filter)"
      [maxSelectedLabels]="0"
      [selectedItemsLabel]="'p-itemsSelected' | translate"
      [displaySelectedLabel]="true"
      [lazy]="searchable"
    >
      <ng-template let-item #item>
        @if (shouldTranslate) {
          {{item.value | translate}}
        } @else {
          {{item.value}}
        }
      </ng-template>
      @if (totalValues !== undefined) {
        <ng-template #footer>
          <span class="text-black-50 ms-3" style="font-size: 0.8rem;">{{'SELECT-FOOTER' | translate: {current: getLength(), total: totalValues} }}</span>
        </ng-template>
      }
    </p-multi-select>
  } @else {
    <p-select
      [id]="'enum-filter-element-' + inputId"
      [options]="options"
      optionValue="key"
      optionLabel="value"
      (onChange)="onFilterChange($event)"
      [showClear]="true"
      [fluid]="true"
      [filter]="searchable"
      filterBy="value"
      [(ngModel)]="value"
      (onFilter)="onFilterTermChange($event.filter)"
    >
      <ng-template let-item #item>
        @if (shouldTranslate) {
          {{item.value | translate}}
        } @else {
          {{item.value}}
        }
      </ng-template>
      <ng-template let-item #selectedItem>{{item.value | translate}}</ng-template>
      @if (totalValues !== undefined) {
        <ng-template #footer>
          <span class="text-black-50 ms-3" style="font-size: 0.8rem;">{{'SELECT-FOOTER' | translate: {current: getLength(), total: totalValues} }}</span>
        </ng-template>
      }
    </p-select>
  }
  <label [for]="'enum-filter-element-' + inputId">{{label | translate}}</label>
</p-floatlabel>